// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The built-in profile a table was built from.
 */
export enum ProfileId {
  Unspecified = 0,
  Elevator = 1,
  EscalatorM3000 = 2,
}
